import {
    DEALERUPLOADAGENTFILE_FAILED,
    DEALERUPLOADAGENTFILE_SUCCESS,
    RESET_DEALERUPLOADAGENTFILE,
    LOADING_DEALERUPLOADAGENTFILE,
    NETWORK_ERROR_DEALERUPLOADAGENTFILE

} from '../types/index';

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERUPLOADAGENTFILE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERUPLOADAGENTFILE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERUPLOADAGENTFILE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERUPLOADAGENTFILE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERUPLOADAGENTFILE:
            return (state = initialState);
        default:
            return state;
    }
};